<template>
  <v-autocomplete
    v-model="selectedEnterprise"
    :items="enterprises"
    :filter="handleCustomFilter"
    :label="$t('users.enterprises')"
    item-text="Name"
    item-value="ID"
    @input="handleChangeEnterprise"
  />
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  export default {
    name: 'RoomsList',
    components: {
    },
    data () {
      return {
        enterprises: [],
        selectedEnterprise: null
      }
    },
    computed: {
      ...mapState('app',['enterpriseID']),
    },
    watch: {
      'enterpriseID': {
        handler: function (newValue) {
          this.selectedEnterprise = newValue
        },
        deep: true
      }
    },
    mounted () {
      this.getEnterprises()
      this.selectedEnterprise = this.enterpriseID
    },
    methods: {
      getEnterprises (enterpriseID) {
        api.getAll('enterprises', true, 1, 100000, '', null)
          .then(response => {
            this.enterprises = response.data
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      handleCustomFilter (item, queryText) {
        const textOne = item.Name.toLowerCase()
        const searchText = queryText ? queryText.toLowerCase() : ''

        return textOne.indexOf(searchText) > -1
      },
      handleChangeEnterprise (value) {
        const aux = this.enterprises.filter(x => x.ID === value)
        this.$store.state.app.enterpriseID = value
        if (aux.length > 0) {
          this.$store.state.app.enterpriseName = aux[0].Name
        } else {
          this.$store.state.app.enterpriseName = ''
        }
      }
    }
  }
</script>

<style scoped>
  .main {
    padding: 15px;
  }
</style>
